import "./Contacts.module.css";
import Header from "@/reusable_sections/Header";
import ContactUs from "./sections/ContactUs";
import OurOperationsHub from "./sections/OurOperationsHub";
import FooterInfo from "@/reusable_sections/Footer";
export default function ContactsPage() {
  return <div>
      <Header />
      <ContactUs />
      <OurOperationsHub />
      <FooterInfo />
    </div>;
}